import { render, staticRenderFns } from "./SettingOne.vue?vue&type=template&id=8574c290&scoped=true"
import script from "./SettingOne.vue?vue&type=script&lang=js"
export * from "./SettingOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8574c290",
  null
  
)

export default component.exports